import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
    {
        path: "intercom",
        children: [{
            path: "",
            loadChildren: () => import("./modules/intercom/intercom.module").then(m => m.IntercomModule),
        }]
    }, {
        path: "**",
        redirectTo: "/intercom"
    }];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
